var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.5424 6.80265L10.0649 3.3252","stroke":"#0A1C33","strokeWidth":"1.8","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.6825 1.7076L3.09814 10.292L6.5756 13.7694L15.16 5.18505C15.5505 4.79452 15.5505 4.16136 15.16 3.77083L13.0968 1.7076C12.7062 1.31707 12.0731 1.31707 11.6825 1.7076Z","stroke":"#0A1C33","strokeWidth":"1.8","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.57462 13.7699L1.73873 15.1284L3.09717 10.2925","stroke":"#0A1C33","strokeWidth":"1.8","strokeLinejoin":"round","key":2})]);
}

Pencil.defaultProps = {"width":"15","height":"15","viewBox":"0 0 17 17","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
